<template>
  <div class="side_box">
    <div>
      <label for="lotnumber">REF number</label>
      <span v-if="this.item">{{this.item.stepID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">Name</label>
      <span v-if="this.item">{{this.item.name}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="subparts">Equipment</label>
      <span v-if="this.item">{{this.item.equipment}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Instruction</label>
      <span v-if="this.item">{{this.item.instruction}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Location</label>
      <span v-if="this.item">{{ "Surgi-Tec" }}</span>
      <span v-else>...</span>
    </div>
    <!-- <div>
      <label for="description">QR code</label>
      <qr-code v-if="this.item" class="print" :text="qrString" :size="120" error-level="L"/>
    </div> -->
    
  </div>
</template>

<script>
export default {
  computed: {
  },
  props: {
    item: Object
  },
  data() {
    return {
      qrString: ''
    }
  },
  mounted() {
    this.qrString = '{"result": "' + this.item.stepID + '", "name": "' + this.item.name + '", "type": "workstation", "company": "SurgiTec"}'
  }
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}
</style>
